import { Deserializable } from '../deserializable';
import { Agent } from './agent.model';

export class AgentMortgageClub implements Deserializable {
  public AgentID: number;
  public MortgageClubCode: string;
  public Number: string;
  public Agent: Agent;
  public Id: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
